import { gql } from '@apollo/client/core';

export const deleteControllerNote = gql`
  mutation deleteControllerNote($id: String) {
    deleteControllerNote(id: $id)
  }
`;
